import React from "react";
import {
  Stack,
  Typography,
  styled,
  Box,
  Rating,
} from "@mui/material";

const Card = styled(Stack)(({ theme }: any) => ({
  justifyContent: "space-evenly",
  width: "275px",
  height: "322px",
  border: `1px solid ${theme.palette.common.borderGrey}`,
  alignItems: "flex-start",
  padding: 24,
}));

interface IndustryEventCardInterface {
  image: string;
  name: string;
  location: string;
  date: string;
  description: string;
}
const StyledRating = styled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "rgba(210, 56, 56, 1)",
  },
});
const IndustryEventCard = ({
  image,
  name,
  location,
  date,
  description,
}: IndustryEventCardInterface) => {
  const [value, setValue] = React.useState<number | null>(2);
  return (
    <Card>
      <Stack alignSelf="center">
        <img src={image} width="255px" height="162px" alt="" />
      </Stack>
      <Typography color="primary" variant="h4">
        {name}
      </Typography>
      <Typography fontWeight={600}>{location}</Typography>
      <Typography>{description}</Typography>
      <Stack direction="row" alignItems="center">
        <Box>
          <StyledRating
            value={value}
            onChange={(_, newValue) => {
              setValue(newValue);
            }}
          />
        </Box>
        <Box
          width=" 7px"
          height="7px"
          style={{ backgroundColor: "black", borderRadius: "10px" }}
          ml={2}
          mr={2}
        />
        <Typography fontWeight={500}>{date} </Typography>
      </Stack>
    </Card>
  );
};
export default IndustryEventCard;
